import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useSearchParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { STORAGE_KEYS } from '_constants/storage';
import { clearLocalValue, clearSessionValue, restoreLocalValue } from '_helpers/storage';
import { resetStore, restoreDetails as restoreUserDetails } from '_store/user/slice';

function App() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    import('bootstrap/dist/js/bootstrap');
  }, []);

  useEffect(() => {
    const restoredUserInfo = restoreLocalValue(STORAGE_KEYS.userInfo);

    if (token && restoredUserInfo) {
      dispatch(resetStore());
      clearLocalValue(STORAGE_KEYS.accessToken);
      clearLocalValue(STORAGE_KEYS.userInfo);
      clearSessionValue(STORAGE_KEYS.activeOrderId);
      clearSessionValue(STORAGE_KEYS.loginFromCRM);
    } else {
      dispatch(restoreUserDetails());
    }
  }, []);

  return (
    <>
      <Outlet />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
